import { updatesData } from '@/mocks/tanhua';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            探花系列平台最新资讯与内容更新，不错过每一部探花佳作
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-0.5 bg-background-300"></div>

            {updatesData.map((item) => (
              <div key={item.id} className="relative pb-8 last:pb-0">
                <div className="absolute left-[-29px] md:left-[-31px] top-1.5 w-3.5 h-3.5 rounded-full bg-primary-500 ring-4 ring-background-100"></div>

                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-500 whitespace-nowrap flex-shrink-0">
                    {item.date}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start gap-2 flex-wrap">
                      <h3 className="text-sm md:text-base font-medium text-foreground-900 leading-snug">
                        {item.title}
                      </h3>
                      <span className="inline-block px-2 py-0.5 text-xs rounded bg-accent-100 text-accent-700 whitespace-nowrap flex-shrink-0">
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-xs md:text-sm text-foreground-600 mt-2 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}